import { fetchList } from '@/api/setting/brand_field'

const brandField = {
  state: {
    map: {},
    inited: {}
  },

  mutations: {
    INIT_DATA: (state, payload) => {
      let id = payload.id
      if (typeof state.inited[id] === 'undefined') {
        state.inited[id] = true
        for (let i = 0; i < payload.data.length; ++i) {
          let v = payload.data[i]
          let n = v.field_name
          if (typeof state.map[id] === 'undefined') {
            state.map[id] = {}
          }
          if (typeof state.map[id][n] === 'undefined') {
            state.map[id][n] = {
              arr: [],
              obj: {}
            }
          }
          state.map[id][n].arr.push({
            value: v.field_value,
            label: v.map_content
          })
          state.map[id][n].obj[v.field_value] = v.map_content
        }
      }
    }
  },

  actions: {
    InitBrandField ({ commit }, brandID) {
      if (typeof this.state.brandField.inited[brandID] !== 'undefined' &&
        this.state.brandField.inited[brandID]
      ) {
        return
      }
      const query = {
        filter: '{brand_id:' + brandID + '}',
        limit: 1000,
        sort: 'id'
      }
      return new Promise((resolve, reject) => {
        fetchList(query).then(response => {
          commit('INIT_DATA', {
            id: brandID,
            data: response.data
          })
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default brandField
